import script from "./EdgeMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./EdgeMenu.vue?vue&type=script&setup=true&lang=js"

import "./EdgeMenu.vue?vue&type=style&index=0&id=3f18af4a&lang=css"

const __exports__ = script;

export default __exports__